import React from 'react';
import './layout.scss';

//Presentational component that displays info icon and text together
function InfoMessage(props) {
  return(
    <>
    <span className="aa-notice-me-info fa fa-arrow-right"></span>
    {' '}
    {props.text}
    </>
  );
}

export default InfoMessage;
